// Menu.js
import React from 'react'
import { StyledMenu } from './Menu.styled'
import { siteConfig } from '@/config/site'

const Menu = ({
  isDemoUser,
  isAdmin,
  isEnterpriseAdmin,
  open,
  setOpen,
  pageState,
  navigate,
  setAuth,
  setIsLoggedIn
}) => {
  return (
    <StyledMenu open={open}>
      <div
        className="header-home"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          setOpen(false)
          navigate('/')
        }}
      >
        Map
      </div>
      <div
        className="header-portfolio"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          setOpen(false)
          navigate('/portfolio')
        }}
      >
        Portfolio
      </div>
      <div
        className="header-reports"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          setOpen(false)
          navigate('/reports')
        }}
      >
        Reports
      </div>
      {isDemoUser && (
        <div
          className="header-reports"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setOpen(false)
            localStorage.setItem('auth', JSON.stringify({}))
            setAuth(null)
            setIsLoggedIn(false)
            window.location.href = siteConfig.landingUrl
          }}
        >
          Exit Demo
        </div>
      )}
      <div
        className="header-profile"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          setOpen(false)
          navigate('/profile')
        }}
      >
        {pageState}
      </div>
      {isAdmin && (
        <div
          className="header-admin"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setOpen(false)
            navigate('/admin')
          }}
        >
          Admin
        </div>
      )}
      {isEnterpriseAdmin && (
        <div
          className="header-enterprise-admin"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setOpen(false)
            navigate('/enterprise')
          }}
        >
          Enterprise Admin
        </div>
      )}
    </StyledMenu>
  )
}
export default Menu
